(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    const gallery = document.querySelector('.product__media-list--grid-desktop');
  const cursor = document.querySelector('.zoom-cursor');

  gallery.addEventListener('mouseover', e => {
      if (e.target.closest('.product__media-item--pdp[data-media-type="image"]')) {
          cursor.classList.add('visible');
      }
  });

  gallery.addEventListener('mouseout', e => {
      if (e.target.closest('.product__media-item--pdp[data-media-type="image"]')) {
          cursor.classList.remove('visible');
      }
  });

  gallery.addEventListener('mousemove', e => {
      cursor.style.left = `${e.clientX}px`;
      cursor.style.top = `${e.clientY}px`;
  });

  document.addEventListener('click', (event) => {
    const mediaItem = event.target.closest('.product__media-item--pdp[data-media-type="image"]');

    if (!mediaItem) return;

    const mediaList = mediaItem.closest('.product__media-list--grid-desktop');

    if (!mediaList) return;

    const productMedia = mediaItem.closest('product-media');
    const zoomButton = productMedia?.querySelector('.product__zoom-button:not([hidden])');

    if (!zoomButton) return;

    const mediaId = mediaItem.dataset.mediaId;

    productMedia.querySelectorAll('[data-media-id]').forEach((item) => {
      item.classList.toggle('is-selected', item.dataset.mediaId === mediaId);
    });

    zoomButton.click();
  });
  } catch(e) { console.error(e); }
})();

})();
